import { TableBody } from '@mui/material';
import React from 'react';

import CertificateRow from './components/CertificateRow';

const ManageCertificateTableBody = ({ listCertificate, page, pageSize }) => {
  return (
    <TableBody>
      {(listCertificate || []).map((certificate, index) => (
        <CertificateRow
          key={index}
          index={index}
          certificate={certificate}
          page={page}
          pageSize={pageSize}
        />
      ))}
    </TableBody>
  );
};

export default ManageCertificateTableBody;
